import { Button } from "@/components/ui/button";
import { PublicLayout } from "@/components/website/PublicLayout";

/**
 * Fallback UI rendered when an uncaught error propagates out of a public
 * route. Rendered inside `PublicLayout` so the theme CSS variables are
 * applied and the page doesn't look like a dev stack trace.
 *
 * Keeps the user on the domain — reload is the recovery path because
 * React Query state is gone and the most reliable fix is a fresh mount.
 */
export function PublicErrorFallback() {
  return (
    <PublicLayout className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <h1 className="text-2xl md:text-3xl font-logo font-bold text-foreground mb-3">
          Something went wrong
        </h1>
        <p className="text-muted-foreground mb-6 font-secondary">
          We hit an unexpected error while loading this page. The team has been
          notified. Please try again in a moment.
        </p>
        <Button
          size="lg"
          onClick={() => window.location.reload()}
          className="min-h-[44px]"
        >
          Try again
        </Button>
      </div>
    </PublicLayout>
  );
}
